import React from "react";

export type Focusable = {
  addEventListener: typeof Element.prototype.addEventListener;
  removeEventListener: typeof Element.prototype.removeEventListener;
};

export const useIsFocused = <T extends Focusable>(ref: React.RefObject<T>): boolean => {
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    const element = ref.current;
    let isMounted = true;

    if (!element) {
      return;
    }

    const handleFocus = () => {
      if (!isMounted) {
        return;
      }

      setIsFocused(true);
    };

    const handleBlur = () => {
      if (!isMounted) {
        return;
      }

      setIsFocused(false);
    };

    element.addEventListener("focus", handleFocus);
    element.addEventListener("blur", handleBlur);

    return () => {
      isMounted = false;
      element.removeEventListener("focus", handleFocus);
      element.removeEventListener("blur", handleBlur);
    };
  }, [ref.current]);

  return isFocused;
};
